module.exports = __webpack_public_path__ + "static/img/wireframe-img-01@m.bcce4de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/wireframe-img-01@m.png
// module id = W0Tp
// module chunks = 0